import { Component } from '@angular/core';
import { ModalController, ViewController, NavParams, Events } from 'ionic-angular';
import { HelperMyRadiant, NotesMyTeamProvider, UserMyRadiant } from '@providers/index';
/**
 * Generated class for the ForbidenloginComponent component.
 *
 * See https://angular.io/api/core/Component for more info on Angular
 * Components.
 */
@Component({
  selector: 'cmp-filter',
  templateUrl: 'cmp.html'
})
export class FilterProjectApps {

  text: string;
  data : any;
  skeleton = false;
  loading : any;
  state = "detail";
  
  keyword = "";
  from_date = "";
  to_date = "";

  company = "";
  listCompany = [
    {
      text: "RUI",
      value: "RUI"
    },
    {
      text: "SPC",
      value: "SPC"
    },
    {
      text: "SPL",
      value: "SPL"
    },
  ];
  parameter_edit: any;
  title: any;
  page: any;

  filter_search = false;
  filter_daterange_month = false;
  
  constructor(
    public viewCtrl : ViewController,
    public navParams : NavParams,
    public helper : HelperMyRadiant,
    public notesProvider : NotesMyTeamProvider,
    public events : Events,
    public userApi : UserMyRadiant,

  ) {
    this.data = this.navParams.get("data");
    this.title = this.navParams.get("title");
    this.page = this.navParams.get("page");

    if (this.page == 'list_project') {
      this.filter_search = true;
    }

    if (this.page == 'detail_project_performance') {
      this.filter_daterange_month = true;
    }
  }

  changeState(state){
    this.state = state;
  }

  tutup(){
    this.viewCtrl.dismiss();
    this.events.publish('project:cancel_filter_list_project');
  }

  inactiveNotes(){
    let me = this;
    let options = {
      title:"Confirmation",
      desc:"Are you sure you want to Inactivate this Notes ?",
      inputType:"",
      className:"swal-text-center"
    };
    this.helper.presentSwalConfirmation(options,() => {
      me.actInactive();
    });
  }

  actInactive(){
    let me = this;
    me.loading = me.helper.showLoading("Loading...");
    this.notesProvider.inactive(this.data).subscribe((resp:any) => {
      if (resp.success) {
        me.loading.dismiss();
        me.viewCtrl.dismiss();
        me.events.publish('notes:inactive');
      }
    });
  }

  filter(){
    let me = this;
    let params = {
      keyword : this.keyword
    };

    if (this.page == 'list_project') {
      this.events.publish('project:filter_list_project', params);
    }
    if (this.page == 'detail_project_performance') {
      this.events.publish('project:filter_detail_project_performance', params);
    }
    me.viewCtrl.dismiss();
    
  }
}



// WEBPACK FOOTER //
// ./src/components/Content/project_filter/cmp.ts